export interface ParkingLot {
  id: ParkingLotId;
  location_id: string;
  location_address: string;
  location_city: string;
  location_latitude: number;
  location_longitude: number;
  location_name: ParkingLotName;
  location_state: string;
  location_zip: string;
  service_id: number;
  status: number;
  created_at: string;
  updated_at: string;
}

export type ParkingLotId = number;

export enum ParkingLotType {
  Reservation = 'reservation',
  DriveIn = 'drive-in',
}

export enum ParkingLotSectionWithReservation {
  Closest = 'closest-to-terminal',
  CoveredPremium = 'covered-premium',
  Premium = 'premium',
  Standard = 'reservation-standard',
  Economy = 'economy',
}

export enum ParkingLotSectionDriveIn {
  Closest = 'closest-to-terminal',
  CoveredPremium = 'covered-premium',
  Premium = 'premium',
  Standard = 'drive-in-standard',
  Street = 'street',
}

export enum ParkingLotSection {
  // Type = With Reservation
  Closest = 'closest-to-terminal',
  Premium = 'premium',
  Covered = 'covered',
  Standard = 'standard',
  // Type = Without Reservation
  Economy = 'economy',
}

export enum ParkingLotName {
  LotA = 'Lot A',
  LotB = 'Lot B',
  LotC = 'Lot C',
  LotD = 'Lot D',
  LotE = 'Lot E',
  LotF = 'Lot F',
  LotG = 'Lot G',
  LotH = 'Lot H',
  LotJ = 'Lot J',
  Valet = 'Valet',
}

// === PARKING LOT SECTION WITH RESERVATION =================================================================

const CLOSEST_PARKING_WITH_RESERVATION_LIST = [ParkingLotName.Valet];
const COVERED_PREMIUM_PARKING_WITH_RESERVATION_LIST = [ParkingLotName.LotD];
const PREMIUM_PARKING_WITH_RESERVATION_LIST = [ParkingLotName.LotA, ParkingLotName.LotB, ParkingLotName.LotC];
const STANDARD_PARKING_WITH_RESERVATION_LIST = [ParkingLotName.LotF];
const ECONOMY_PARKING_WITH_RESERVATION_LIST = [ParkingLotName.LotE];

export const isClosestParkingWithReservation = (lot: ParkingLot) => CLOSEST_PARKING_WITH_RESERVATION_LIST.includes(lot.location_name);
export const isCoveredPremiumParkingWithReservation = (lot: ParkingLot) => COVERED_PREMIUM_PARKING_WITH_RESERVATION_LIST.includes(lot.location_name);
export const isPremiumParkingWithReservation = (lot: ParkingLot) => PREMIUM_PARKING_WITH_RESERVATION_LIST.includes(lot.location_name);
export const isStandardParkingWithReservation = (lot: ParkingLot) => STANDARD_PARKING_WITH_RESERVATION_LIST.includes(lot.location_name);
export const isEconomyParkingWithReservation = (lot: ParkingLot) => ECONOMY_PARKING_WITH_RESERVATION_LIST.includes(lot.location_name);

export const filterClosestParkingWithReservation = (lots: ParkingLot[]) => lots.filter(isClosestParkingWithReservation);
export const filterCoveredPremiumParkingWithReservation = (lots: ParkingLot[]) => lots.filter(isCoveredPremiumParkingWithReservation);
export const filterPremiumParkingWithReservation = (lots: ParkingLot[]) => lots.filter(isPremiumParkingWithReservation);
export const filterStandardParkingWithReservation = (lots: ParkingLot[]) => lots.filter(isStandardParkingWithReservation);
export const filterEconomyParkingWithReservation = (lots: ParkingLot[]) => lots.filter(isEconomyParkingWithReservation);

// === PARKING LOT SECTION DRIVE-IN ==========================================================================

const CLOSEST_PARKING_DRIVE_IN_LIST = [];
const COVERED_PREMIUM_PARKING_DRIVE_IN_LIST = [];
const PREMIUM_PARKING_DRIVE_IN_LIST = [];
const STANDARD_PARKING_DRIVE_IN_LIST = [];
const STREET_PARKING_DRIVE_IN_LIST = [];

export const getClosestParkingsDriveIn = () => CLOSEST_PARKING_DRIVE_IN_LIST;
export const getCoveredPremiumParkingsDriveIn = () => COVERED_PREMIUM_PARKING_DRIVE_IN_LIST;
export const getPremiumParkinsgDriveIn = () => PREMIUM_PARKING_DRIVE_IN_LIST;
export const getStandardParkingsDriveIn = () => STANDARD_PARKING_DRIVE_IN_LIST;
export const getStreetParkingsDriveIn = () => STREET_PARKING_DRIVE_IN_LIST;
